import Button from 'components/button/Button';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';
import { StyledPageHeader } from './PropertySettingsSeasonalityTab.styles';
import PropertySettingsSeasonalityTabHeader from './PropertySettingsSeasonalityTabHeader';
import SeasonalRulesTable from './table/SeasonalRulesTable';

const PropertySettingsSeasonalityTab = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <section>
      <PropertySettingsSeasonalityTabHeader />
      <StyledPageHeader
        title={t('pageProperty.seasonality.sectionTitle')}
        noDivider
        buttons={
          <Button
            bsStyle="primary"
            data-testid="add-seasonal-rule-btn"
            onClick={() => navigate('./add')}
          >
            {t('pageProperty.seasonality.addSeasonalRule')}
          </Button>
        }
      />
      <SeasonalRulesTable />
      <Outlet />
    </section>
  );
};

export default PropertySettingsSeasonalityTab;
